/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Comment } from './comment';
import { TimespanString } from './timespanString';
import { NotificationDto } from './notificationDto';
import { TimespanDataPlan } from './timespanDataPlan';
import { DeviceMovebankInformationDto } from './deviceMovebankInformationDto';
import { ShareDto } from './shareDto';
import { TimespanLong } from './timespanLong';
import { TimespanNetworkStatus } from './timespanNetworkStatus';
import { ParameterData } from './parameterData';
import { DeviceMetaInformationDto } from './deviceMetaInformationDto';
import { DataForwardingRuleDto } from './dataForwardingRuleDto';
import { Build } from './build';
import { StringTimespan } from './stringTimespan';
import { TimespanComProvider } from './timespanComProvider';


export interface LongRangeDeviceAdminDto { 
    idDevice?: number;
    id?: number;
    insertTs?: string;
    updateTs?: string;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    parameterDataList?: Array<ParameterData>;
    warranty?: string;
    testDevice?: boolean;
    userSubsystemVisibility?: Array<boolean>;
    batteryTimeline?: Array<StringTimespan>;
    pcbTypeId?: string;
    gpsPlusDevice?: boolean;
    buildInProduction?: Build;
    currentBuild?: Build;
    previousBuilds?: Array<Build>;
    comments?: Array<Comment>;
    replacedById?: number;
    nfcTagUid?: string;
    replaces?: number;
    name?: string;
    shares?: Array<ShareDto>;
    orderName?: string;
    deviceManufacturingStatus?: LongRangeDeviceAdminDto.DeviceManufacturingStatusEnum;
    comType?: LongRangeDeviceAdminDto.ComTypeEnum;
    knownToSendBrokenMessages?: boolean;
    comIdTimeline?: Array<TimespanString>;
    comProviderTimeline?: Array<TimespanComProvider>;
    dataPlanTimeline?: Array<TimespanDataPlan>;
    networkStatusTimeline?: Array<TimespanNetworkStatus>;
    paymentAccountTimeline?: Array<TimespanLong>;
    airtimeNetworkStatusChangeRequested?: LongRangeDeviceAdminDto.AirtimeNetworkStatusChangeRequestedEnum;
    notifications?: Array<NotificationDto>;
    emailForwarding?: Array<DataForwardingRuleDto>;
    deviceMetaInformation?: DeviceMetaInformationDto;
    movebankInformation?: Array<DeviceMovebankInformationDto>;
    _class: string;
}
export namespace LongRangeDeviceAdminDto {
    export const DeviceManufacturingStatusEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type DeviceManufacturingStatusEnum = typeof DeviceManufacturingStatusEnum[keyof typeof DeviceManufacturingStatusEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
}


